import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  PngIcon,
  TextButton,
  TextButtonSize,
  TextButtonVariant,
} from '../../../Molecules';

import './ExpiredTemplate.css';

type ExpiredTemplateProps = {
  description?: string;
  onClick: () => void;
};

export const ExpiredTemplate = memo(
  ({ description, onClick }: ExpiredTemplateProps) => {
    const { t } = useTranslation();
    return (
      <div className="expired">
        <div className="centered-container">
          <PngIcon className="tick-icon" name="Notice" />
          <h2>{t('Expired')}</h2>
          <p>{t(description ?? 'The invitation has expired.')}</p>
          <TextButton
            text={t('OK')}
            size={TextButtonSize.Medium}
            variant={TextButtonVariant.Cyan}
            onClick={onClick}
          />
        </div>
      </div>
    );
  },
);
